import script from "./CostingTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CostingTab.vue?vue&type=script&setup=true&lang=js"

import "./CostingTab.vue?vue&type=style&index=0&id=a09b6022&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a09b6022"]])

export default __exports__